import React, { useState } from 'react';
import { 
  FiFilter, 
  FiX, 
  FiChevronDown, 
  FiCalendar,
  FiUser,
  FiSettings
} from 'react-icons/fi';

export default function AdvancedFilter({
  isOpen,
  onToggle,
  onApply,
  onClear,
  filters = {},
  entityType = 'users'
}) {
  const [localFilters, setLocalFilters] = useState(filters);

  const handleFilterChange = (key, value) => {
    setLocalFilters(prev => ({
      ...prev,
      [key]: value
    }));
  };

  const handleApply = () => {
    onApply(localFilters);
    onToggle();
  };

  const handleClear = () => {
    setLocalFilters({});
    onClear();
  };

  const getFilterFields = () => {
    switch (entityType) {
      case 'users':
        return [
          {
            id: 'role',
            label: 'User Role',
            type: 'select',
            options: [
              { value: '', label: 'All Roles' },
              { value: 'Standard', label: 'Standard' },
              { value: 'Admin', label: 'Admin' },
              { value: 'VIP/Gifted', label: 'VIP/Gifted' }
            ]
          },
          {
            id: 'subscription_status',
            label: 'Subscription Status',
            type: 'select',
            options: [
              { value: '', label: 'All Statuses' },
              { value: 'active', label: 'Active' },
              { value: 'inactive', label: 'Inactive' },
              { value: 'cancelled', label: 'Cancelled' },
              { value: 'expired', label: 'Expired' }
            ]
          },
          {
            id: 'is_active',
            label: 'Account Status',
            type: 'select',
            options: [
              { value: '', label: 'All Accounts' },
              { value: '1', label: 'Active Accounts' },
              { value: '0', label: 'Suspended Accounts' }
            ]
          },
          {
            id: 'trial_used',
            label: 'Trial Status',
            type: 'select',
            options: [
              { value: '', label: 'All Users' },
              { value: '0', label: 'Trial Available' },
              { value: '1', label: 'Trial Used' }
            ]
          },
          {
            id: 'created_from',
            label: 'Registered From',
            type: 'date'
          },
          {
            id: 'created_to',
            label: 'Registered To',
            type: 'date'
          },
          {
            id: 'last_active_from',
            label: 'Last Active From',
            type: 'date'
          },
          {
            id: 'last_active_to',
            label: 'Last Active To',
            type: 'date'
          }
        ];

      case 'organizations':
        return [
          {
            id: 'organization_type',
            label: 'Organization Type',
            type: 'select',
            options: [
              { value: '', label: 'All Types' },
              { value: 'business', label: 'Business' },
              { value: 'education', label: 'Education' },
              { value: 'government', label: 'Government' },
              { value: 'nonprofit', label: 'Non-profit' }
            ]
          },
          {
            id: 'member_count_min',
            label: 'Min Members',
            type: 'number'
          },
          {
            id: 'member_count_max',
            label: 'Max Members',
            type: 'number'
          },
          {
            id: 'created_from',
            label: 'Created From',
            type: 'date'
          },
          {
            id: 'created_to',
            label: 'Created To',
            type: 'date'
          }
        ];

      case 'questions':
        return [
          {
            id: 'category_id',
            label: 'Category',
            type: 'select',
            options: [
              { value: '', label: 'All Categories' },
              // TODO: Load from API
            ]
          },
          {
            id: 'difficulty',
            label: 'Difficulty',
            type: 'select',
            options: [
              { value: '', label: 'All Difficulties' },
              { value: '1', label: 'Level 1 (Easy)' },
              { value: '2', label: 'Level 2 (Medium)' },
              { value: '3', label: 'Level 3 (Hard)' },
              { value: '4', label: 'Level 4 (Expert)' },
              { value: '5', label: 'Level 5 (Master)' }
            ]
          },
          {
            id: 'status',
            label: 'Status',
            type: 'select',
            options: [
              { value: '', label: 'All Statuses' },
              { value: 'draft', label: 'Draft' },
              { value: 'pending', label: 'Pending Review' },
              { value: 'approved', label: 'Approved' },
              { value: 'rejected', label: 'Rejected' }
            ]
          },
          {
            id: 'has_media',
            label: 'Media Content',
            type: 'select',
            options: [
              { value: '', label: 'All Questions' },
              { value: '1', label: 'Has Media' },
              { value: '0', label: 'No Media' }
            ]
          }
        ];

      default:
        return [];
    }
  };

  if (!isOpen) {
    return (
      <button
        onClick={onToggle}
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '0.5rem',
          padding: '0.75rem 1rem',
          backgroundColor: 'white',
          border: '1px solid #D1D5DB',
          borderRadius: '8px',
          fontSize: '0.875rem',
          cursor: 'pointer',
          color: Object.keys(filters).length > 0 ? '#3B82F6' : '#6B7280'
        }}
      >
        <FiFilter size={16} />
        Advanced Filter
        {Object.keys(filters).length > 0 && (
          <span style={{
            backgroundColor: '#3B82F6',
            color: 'white',
            borderRadius: '50%',
            width: '20px',
            height: '20px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '0.75rem',
            fontWeight: '500'
          }}>
            {Object.keys(filters).length}
          </span>
        )}
      </button>
    );
  }

  return (
    <div style={{
      position: 'absolute',
      top: '100%',
      right: 0,
      marginTop: '0.5rem',
      backgroundColor: 'white',
      borderRadius: '12px',
      boxShadow: '0 10px 25px rgba(0, 0, 0, 0.15)',
      border: '1px solid #E2E8F0',
      padding: '1.5rem',
      minWidth: '400px',
      maxWidth: '500px',
      zIndex: 1000
    }}>
      {/* Header */}
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: '1.5rem',
        paddingBottom: '1rem',
        borderBottom: '1px solid #E2E8F0'
      }}>
        <h3 style={{ margin: 0, fontSize: '1.125rem', fontWeight: '600', color: '#1F2937' }}>
          Advanced Filters
        </h3>
        <button
          onClick={onToggle}
          style={{
            padding: '0.5rem',
            backgroundColor: 'transparent',
            border: 'none',
            cursor: 'pointer',
            color: '#6B7280',
            borderRadius: '4px'
          }}
        >
          <FiX size={20} />
        </button>
      </div>

      {/* Filter Fields */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
        gap: '1rem',
        marginBottom: '1.5rem'
      }}>
        {getFilterFields().map((field) => (
          <div key={field.id}>
            <label style={{
              display: 'block',
              marginBottom: '0.5rem',
              fontSize: '0.875rem',
              fontWeight: '500',
              color: '#374151'
            }}>
              {field.label}
            </label>
            
            {field.type === 'select' ? (
              <select
                value={localFilters[field.id] || ''}
                onChange={(e) => handleFilterChange(field.id, e.target.value)}
                style={{
                  width: '100%',
                  padding: '0.75rem',
                  border: '1px solid #D1D5DB',
                  borderRadius: '6px',
                  fontSize: '0.875rem',
                  backgroundColor: 'white'
                }}
              >
                {field.options?.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
            ) : field.type === 'date' ? (
              <input
                type="date"
                value={localFilters[field.id] || ''}
                onChange={(e) => handleFilterChange(field.id, e.target.value)}
                style={{
                  width: '100%',
                  padding: '0.75rem',
                  border: '1px solid #D1D5DB',
                  borderRadius: '6px',
                  fontSize: '0.875rem'
                }}
              />
            ) : field.type === 'number' ? (
              <input
                type="number"
                value={localFilters[field.id] || ''}
                onChange={(e) => handleFilterChange(field.id, e.target.value)}
                placeholder={`Enter ${field.label.toLowerCase()}`}
                style={{
                  width: '100%',
                  padding: '0.75rem',
                  border: '1px solid #D1D5DB',
                  borderRadius: '6px',
                  fontSize: '0.875rem'
                }}
              />
            ) : (
              <input
                type="text"
                value={localFilters[field.id] || ''}
                onChange={(e) => handleFilterChange(field.id, e.target.value)}
                placeholder={`Enter ${field.label.toLowerCase()}`}
                style={{
                  width: '100%',
                  padding: '0.75rem',
                  border: '1px solid #D1D5DB',
                  borderRadius: '6px',
                  fontSize: '0.875rem'
                }}
              />
            )}
          </div>
        ))}
      </div>

      {/* Actions */}
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        paddingTop: '1rem',
        borderTop: '1px solid #E2E8F0'
      }}>
        <button
          onClick={handleClear}
          style={{
            padding: '0.75rem 1rem',
            backgroundColor: 'transparent',
            border: '1px solid #D1D5DB',
            borderRadius: '6px',
            fontSize: '0.875rem',
            cursor: 'pointer',
            color: '#6B7280'
          }}
        >
          Clear All
        </button>
        
        <div style={{ display: 'flex', gap: '0.75rem' }}>
          <button
            onClick={onToggle}
            style={{
              padding: '0.75rem 1rem',
              backgroundColor: 'transparent',
              border: '1px solid #D1D5DB',
              borderRadius: '6px',
              fontSize: '0.875rem',
              cursor: 'pointer',
              color: '#374151'
            }}
          >
            Cancel
          </button>
          
          <button
            onClick={handleApply}
            style={{
              padding: '0.75rem 1.5rem',
              backgroundColor: '#3B82F6',
              color: 'white',
              border: 'none',
              borderRadius: '6px',
              fontSize: '0.875rem',
              fontWeight: '500',
              cursor: 'pointer'
            }}
          >
            Apply Filters
          </button>
        </div>
      </div>
    </div>
  );
}